import axios from "axios";


export const url = 'https://post.rahvar.co/api/v1'
export const baseurl = 'https://goldentishk.com'



export const adminlogin = (d) => {
   return  axios.post(`${url}/postcenterlogin`,d)
}





export const getDashboard = (bear)=>{
   return axios.get(`${url}/postcenter/dashboard/index`,bear)
}


export const getParcel = (bear)=>{
   return axios.get(`${url}/postcenter/parcel/list`,bear)
}


export const getPostcenterslist = (bear)=>{
   return axios.get(`${url}/admin/postcenter/list`,bear)
}


export const getProviences = ()=>{
   return axios.get(`${url}/provinces`)
}

export const getCitylist = (d)=>{
   return axios.get(`${url}/cities`,d)
}
export const Parcelondeliver = (d,c) => {
   return axios.post(`${url}/postcenter/parcel/hashedpostman`,d,c)
}

export const parcelDelivered = (d,c) => {
  return axios.post(`${url}/postcenter/parcel/delivered`, d,c)
}

export const parcelIn = (d,c) => {
   return axios.post(`${url}/postcenter/parcel/receive`, d,c)
}

export const parcelOut = (d,c) => {
   return axios.post(`${url}/postcenter/parcel/send`, d,c)
}
export const parcelReturn = (d,c) => {
  return axios.post(`${url}/postcenter/parcel/returned`, d,c)
}

export const parcelDetails = (d) => {
   return axios.post(`${url}/search`, d)

}













export const getBlogs = (bear)=>{
   return axios.get(`${url}/admin/blog/index`,bear)
}

export const getNews = (bear)=>{
   return axios.get(`${url}/admin/news/index`,bear)
}
export const getProducts = (bear)=>{
   return axios.get(`${url}/admin/product/index`,bear)
}

export const getCertificates = (bear)=>{
   return axios.get(`${url}/admin/certificate/index`,bear)
}

export const getSingleBlog = (bear,id)=>{
   return axios.get(`${url}/admin/blog/info/${id}`,bear)
}

export const getSingleNews = (bear,id)=>{
   return axios.get(`${url}/admin/news/info/${id}`,bear)
}





export const webpageoptions = (bear)=>{
   return axios.get(`${url}/admin/option/index`,bear)
}


export const updateWebpageoptions = (data,bear)=>{
   return axios.post(`${url}/admin/option/update`,data,bear)
}









export const getEvents = (bear)=>{
   return axios.get(`${url}/admin/concert/index`,bear)
}

export const getMessages = (bear)=>{
   return axios.get(`${url}/admin/contact/index`,bear)
}




